<div class="main">
    <div class="flex justify-between items-center flex-wrap py-2 px-4">
        <h3 class="text-lg font-semibold text-gray-900 flex items-center">
            <span>Shift Roster</span>
        </h3>
        <div class="flex gap-4 justify-end">
            <Button class="button-blue inline-flex items-center whitespace-nowrap" (click)="openShift()">Shift Management</Button>
            <Button class="button-blue inline-flex items-center whitespace-nowrap" (click)="openOperator()">Operator Management</Button>
            <button class="button-blue" (click)="addRoster()">Add Shift Roster</button>
        </div>
    </div>
    <div class="pt-2 px-4">
        <div class="flex flex-col lg:flex-row items-center justify-between pb-4 pt-0">
          <div class="flex items-center space-x-4 w-96">
            <h3 class="text-sm font-semibold text-gray-700 w-full">Select Department</h3>
            <select id="department" [ngModel]="departmentId()" class="textField" (ngModelChange)="onDepartmentChange($event)">
              <option [ngValue]="null" hidden disabled selected>Choose a Department</option>
              @for (dept of $$departmentDTO(); track dept.departmentId) {
                <option [ngValue]="dept.departmentId">{{ dept.departmentName | titlecase }}</option>
              }
            </select>
          </div>
          <div class="flex items-center space-x-2 w-[600px]">
            <select class="textField" [(ngModel)]="selectedYear" (change)="updateCalendarYear(selectedYear)">
              @for (year of years; track year) {
                <option [value]="year">{{ year }}</option>
              }
            </select>
            <select class="textField" [(ngModel)]="selectedMonth" (change)="updateCalendarMonth(selectedMonth)">
              @for (month of months; track $index) {
                <option [value]="$index">{{ month }}</option>
              }
            </select>
            <button class="button-gray" (click)="previousWeek()" [disabled]="startDayIndex() === 0">
              Previous
            </button>
            <button class="button-gray" (click)="nextWeek()" [disabled]="startDayIndex() + 7 >= daysInCurrentMonth">
              Next
            </button>
          </div>
        </div>
    </div>
    <div>
        <div class="overflow-x-auto overflow-y-auto max-h-[800px]">
          <table class="table w-full">
            <thead class="sticky top-0 z-20 bg-gray-50">
              <tr>
                <th class="px-2 py-3 sticky left-0 bg-gray-50 z-10">Machines</th>
                <th class="px-6 py-3 sticky left-0 bg-gray-50 z-10 w-48">Shift</th>
                <th class="px-6 py-3 text-center" *ngFor="let day of calendarDays">
                  {{ day | date: 'MMM d' }}
                </th>
              </tr>
            </thead>
            <tbody>
              @for (dep of $$shiftRosterGetByDepartmentDTO(); track dep) {
                @for (machine of dep.machines; track machine) {
                  <tr class="border-b border-b-gray-200">
                    <td class="px-6 py-2 text-sm font-medium sticky left-0 z-10 
                               w-48 max-w-48 overflow-hidden whitespace-nowrap text-ellipsis">
                        {{ machine.machineName }}
                    </td>
                    <td class="px-6 sticky left-0 z-10 relative w-24 h-8">
                        <div class="relative h-full">
                            @for (shift of $$ShiftsByMachine().get(machine.machineId) ?? []; track shift.shiftId) {
                            <div class="w-full h-8 border-gray-100 pt-2 overflow-hidden whitespace-nowrap">
                                <span class="text-xs text-gray-500 truncate block">{{ shift.shiftName }}</span>
                            </div>
                            }
                        </div>
                    </td>
                    <td *ngFor="let day of calendarDays" class="w-96 border border-b-gray-200">
  <div class="flex flex-col p-2 space-y-1">
    @for (shift of $$ShiftsByMachine().get(machine.machineId) ?? []; track shift.shiftId) {
      <div class="px-2 py-1 text-xs rounded-md text-container cursor-pointer"
           [ngClass]="getShiftClass(machine.shiftRoster, day, shift.shiftName, 'ACTIVE')">
        <span>
          <div *ngIf="getOperatorWithIds(machine.shiftRoster, day, shift.shiftName).length > 0; else noOperator">
            <span (click)="openOperatorUpdate(machine.machineId, machine.shiftRoster, day, shift.shiftName, getOperatorWithIds(machine.shiftRoster, day, shift.shiftName))"
                  class="cursor-pointer">
              <span *ngFor="let op of getOperators(machine.shiftRoster, day, shift.shiftName, 'ACTIVE'); let last = last">
                {{ op }}<span *ngIf="!last">, </span>
              </span>
            </span>
          </div>
          <ng-template #noOperator>
            <span class="cursor-pointer text-gray-400 italic">
              No operator ({{ shift.shiftName }})
            </span>
          </ng-template>
        </span>
      </div>
    }
  </div>
</td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
    </div>
</div>

@if(modal.$$operatorManage()){
    <div id="operation-modal" tabindex="-1" aria-hidden="true"
        class="fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
        <div class="relative p-4 w-full max-w-5xl mx-auto bg-white rounded-lg shadow-lg max-h-80vh overflow-y-auto">
            <div class="relative">
                <div class="flex items-center justify-between p-4 border-b rounded-t">
                <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                    <span>Employee Management</span>
                    <span class="status-badge ml-4"></span>
                </h3>
                <button type="button" (click)="modal.$$operatorManage.set(false)" (click)="resetForm()"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center"
                    data-modal-toggle="crud-modal">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
                </div>
                <div class="p-4 bg-gray-200 rounded-lg pt-2">
                    <div>
                        <span class="font-semibold text-sm text-gray-600">Add New Employee</span>
                    </div>
                    <div class="flex flex-row gap-4 pt-4">
                        <input type="text" min="0" step="0.01" class="textField flex-1" placeholder="Operator Name" [(ngModel)]="operaterName"/>
                        <input type="text" min="0" step="0.01" class="textField flex-1" placeholder="Employee Number" [(ngModel)]="empNo"/>
                         <select id="section" [(ngModel)]="section" class="textField flex-1">
                            <option value="" hidden disabled selected>Choose a Section</option>
                            @for (type of $$MachineTypeDTO(); track type.machineTypeName) {
                                <option [value]="type.machineTypeName">{{ type.machineTypeName | titlecase }}</option>
                            }
                        </select>
                        <select id="department-operator" [ngModel]="departmentId()" class="textField flex-1" disabled>
                            <option [ngValue]="null" hidden disabled selected>Choose a Department</option>
                            @for (dept of $$departmentDTO(); track dept.departmentId) {
                                <option [ngValue]="dept.departmentId">{{ dept.departmentName | titlecase }}</option>
                            }
                        </select>
                        <div class="flex gap-2">
                            <button class="button-blue inline-flex items-center whitespace-nowrap" (click)="isEditMode ? updateOperator() : addNewOperator()">
                            {{ isEditMode ? 'Update' : 'Add new' }}
                            </button>
                            <button   *ngIf="isEditMode" class="button-red inline-flex items-center whitespace-nowrap" (click)="resetForm()">
                                Cancel
                            </button>
                        </div>
                    </div>

                </div>
                <div class="overflow-x-auto pt-2 max-h-80">
                    <div class="table-wrapper overflow-x-auto">
                        <table class="table">
                            <thead class="table-thead">
                                <tr>
                                    <th scope="col" class="px-6 py-3">Operator Name</th>
                                    <th scope="col" class="px-6 py-3">Employee Number</th>
                                    <th scope="col" class="px-6 py-3">Section</th>
                                    <th scope="col" class="px-6 py-3">Department</th>
                                    <th scope="col" class="px-6 py-3">Edit</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (operator of $$OperatorsDTO(); track operator) {
                                    <tr class="bg-white border-b hover:bg-blue-100 cursor-pointer">
                                        <td class="px-6 py-2 text-sm">{{ operator.operatorName| uppercase }}
                                        <td class="px-6 py-2 text-sm">{{ operator.employeeNo| uppercase }}
                                            <td class="px-6 py-2 text-sm">{{ operator.section| uppercase }}
                                        <td class="px-6 py-2 text-sm">{{ operator.department }}
                                        <td class="px-6 py-4" (click)="openEdit(operator.operatorId, operator.employeeNo, operator.operatorName, operator.department, operator.departmentId, operator.section)">
                                            <svg width="20" height="20" class="cursor-pointer" viewBox="0 0 20 20" fill="none">
                                                <path d="M11 14H10V10H9M10 6H10.01M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
                                                    stroke="#388E3C" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round"/>
                                            </svg>
                                        </td>
                                    </tr>
                                } @empty {
                                    <tr>
                                        <td colspan="12" class="px-6 py-10">
                                            <div class="flex flex-col items-center justify-center text-center">
                                                <p class="text-xl font-semibold text-gray-700 mb-2">No Operators
                                                    Found</p>
                                                <p class="text-gray-500">We couldn't find any operators</p>
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

@if(modal.$$shiftManage()) {
    <div id="operation-modal" tabindex="-1" aria-hidden="true"
        class="fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
        <div class="relative p-4 w-full max-w-5xl mx-auto bg-white rounded-lg shadow-lg max-h-80vh overflow-y-auto">
            <div class="relative">
                <div class="flex items-center justify-between p-4 border-b rounded-t">
                <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                    <span>Shift Management</span>
                    <span class="status-badge ml-4"></span>
                </h3>
                <button type="button" (click)="modal.$$shiftManage.set(false)"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center"
                    data-modal-toggle="crud-modal">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
                </div>
                <div class="overflow-x-auto pt-2 max-h-80">
                    <div class="table-wrapper overflow-x-auto">
                        <table class="table">
                            <thead class="table-thead">
                                <tr>
                                    <th scope="col" class="px-6 py-3">Department</th>
                                    <th scope="col" class="px-6 py-3">Shift</th>
                                    <th scope="col" class="px-6 py-3">Start Time</th>
                                    <th scope="col" class="px-6 py-3">End Time</th>
                                    <th scope="col" class="px-6 py-3">Edit</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (shift of $$ShiftDTO(); track shift) {
                                    <tr class="bg-white border-b hover:bg-blue-100 cursor-pointer">
                                        <td class="px-6 py-2 text-sm">{{ shift.department| uppercase }}
                                        <td class="px-6 py-2 text-sm">{{ shift.shiftName| uppercase }}
                                        <td class="px-6 py-2 text-sm">{{ shift.startTime }}
                                        <td class="px-6 py-2 text-sm">{{ shift.endTime }}
                                        <td class="px-6 py-4">
                                            <svg width="20" height="20" class="cursor-pointer" viewBox="0 0 20 20" fill="none">
                                                <path d="M11 14H10V10H9M10 6H10.01M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
                                                    stroke="#388E3C" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round"/>
                                            </svg>
                                        </td>
                                    </tr>
                                } @empty {
                                    <tr>
                                        <td colspan="12" class="px-6 py-10">
                                            <div class="flex flex-col items-center justify-center text-center">
                                                <p class="text-xl font-semibold text-gray-700 mb-2">No Any Shifts
                                                    Found</p>
                                                <p class="text-gray-500">We couldn't find any defined shifts</p>
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

@if(modal.$$shiftRoster()) {
    <div id="operation-modal" tabindex="-1" aria-hidden="true"
        class="fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
        <div class="relative p-4 w-full max-w-5xl mx-auto bg-white rounded-lg shadow-lg max-h-80vh overflow-y-auto">
            <div class="relative">
                <div class="flex items-center justify-between p-4 border-b rounded-t">
                <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                    <span>Add Shift Roster</span>
                    <span class="status-badge ml-4"></span>
                </h3>
                <button type="button" (click)="closeAddRoster()"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center"
                    data-modal-toggle="crud-modal">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
                </div>
            </div>
            <div class="px-4 pt-2">
                <div class="flex gap-2 rounded-lg p-2 mt-2 w-fit bg-gray-200">
                    <button
                        class="px-4 py-2 rounded-md text-sm font-medium transition-all"
                        [ngClass]="addMode === 'daily'
                        ? 'bg-blue-500 text-white shadow'
                        : 'text-gray-600 hover:bg-gray-200'"
                        (click)="addMode = 'daily'">
                        Daily Add
                    </button>

                    <button
                        class="px-4 py-2 rounded-md text-sm font-medium transition-all"
                        [ngClass]="addMode === 'bulk'
                        ? 'bg-blue-500 text-white shadow'
                        : 'text-gray-600 hover:bg-gray-200'"
                        (click)="addMode = 'bulk'">
                        Bulk Add
                    </button>
                </div>            
                <div *ngIf="addMode === 'daily'">
                    <div class="flex pt-4 gap-2">
                        <select id="machine-daily" [(ngModel)]="machineId" class="textField flex-1" (ngModelChange)="onMachineChange()">
                            <option [ngValue]="null" hidden disabled selected>Choose Machine</option>
                            @for (machine of $$availableMachines(); track machine.machineId) {
                                <option [ngValue]="machine.machineId">
                                    {{ machine.machineName | titlecase }}
                                </option>
                            }
                        </select>

                        <input type="date" class="textField flex-1" [(ngModel)]="selectedDate"/>
                        <select id="shift-daily" [(ngModel)]="shiftId" class="textField flex-1">
                            <option [ngValue]="null" hidden disabled selected>Choose Shift</option>
                            @for (shift of getShiftsForSelectedMachine(); track shift.shiftId) {
                                <option [ngValue]="shift.shiftId">{{ shift.shiftName | titlecase }}</option>
                            }
                        </select>
                        <div class="relative">
                            <input
                                type="search"
                                class="textField flex-1 w-full"
                                placeholder="Search Operator"
                                [(ngModel)]="searchTerm"
                                (focus)="dropdownOpenN = true"
                            />

                            <ul
                                *ngIf="dropdownOpenN"
                                class="absolute bg-white border rounded-md mt-1 max-h-40 w-full overflow-y-auto z-10 shadow"
                            >
                                <li
                                    *ngFor="let operator of filteredOperators()"
                                    (click)="selectOperator(operator)"
                                    class="p-2 hover:bg-gray-100 cursor-pointer"
                                >
                                    {{ operator.operatorName | titlecase }}
                                </li>

                                <li *ngIf="filteredOperators().length === 0" class="p-2 text-gray-500">
                                    No results found
                                </li>
                            </ul>
                        </div>

                        <button class="button-blue inline-flex items-center gap-2" (click)="addShiftRosterEntry()" (keyup.enter)="addShiftRosterEntry()">
                            Add
                        </button>
                    </div>
                </div>
                <div *ngIf="addMode === 'bulk'">
                <div class="flex gap-2 pt-4">
                    <select id="machine-bulk" class="textField flex-1" [(ngModel)]="machineId" (ngModelChange)="onMachineChange()">
                        <option [ngValue]="null" hidden disabled selected>Choose Machine</option>
                        @for (machine of $$availableMachines(); track machine.machineId) {
                            <option [ngValue]="machine.machineId">{{ machine.machineName| titlecase }}</option>
                        }
                    </select>
                    <input type="date" class="textField flex-1" [(ngModel)]="bulkStartDate"/>
                    <input type="date" class="textField flex-1" [(ngModel)]="bulkEndDate"/>
                    <select id="shift-bulk" class="textField flex-1" [(ngModel)]="shiftId">
                        <option [ngValue]="null" hidden disabled selected>Choose Shift</option>
                        @for (shift of getShiftsForSelectedMachine(); track shift.shiftId) {
                            <option [ngValue]="shift.shiftId">{{ shift.shiftName | titlecase }}</option>
                        }
                    </select>
                    
                    <div class="relative">
                            <input
                                type="search"
                                class="textField flex-1 w-full"
                                placeholder="Search Operator"
                                [(ngModel)]="searchTerm"
                                (focus)="dropdownOpenN = true"
                            />
                            
                            <ul
                                *ngIf="dropdownOpenN"
                                class="absolute bg-white border rounded-md mt-1 max-h-40 w-full overflow-y-auto z-10 shadow"
                            >
                                <li
                                    *ngFor="let operator of filteredOperators()"
                                    (click)="selectOperator(operator)"
                                    class="p-2 hover:bg-gray-100 cursor-pointer"
                                >
                                    {{ operator.operatorName | titlecase }}
                                </li>

                                <li *ngIf="filteredOperators().length === 0" class="p-2 text-gray-500">
                                    No results found
                                </li>
                            </ul>
                    </div>
                    <button class="button-blue" (click)="addBulkShiftRosterEntry()">Add Bulk</button>
                </div>
                </div>
                <div class="overflow-x-auto pt-2 max-h-80">
                    <div class="table-wrapper overflow-x-auto">
                        <table class="table">
                            <thead class="table-thead">
                                <tr>
                                    <th scope="col" class="px-6 py-3">Date</th>
                                    <th scope="col" class="px-6 py-3">Machine</th>
                                    <th scope="col" class="px-6 py-3">Shift</th>
                                    <th scope="col" class="px-6 py-3">Operator</th>
                                    <th scope="col" class="px-6 py-3">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (entry of shiftRosterEntries; track entry) {
                                    <tr>
                                        <td class="px-6 py-2">{{ entry.date }}</td>
                                        <td class="px-6 py-2">{{ getMachineName(entry.machineId) }}</td>
                                        <td class="px-6 py-2">{{ getShiftName(entry.shiftId, entry.machineId) }}</td>
                                        <td class="px-6 py-2">{{ getOperatorName(entry.operatorId) }}</td>
                                        <td class="px-6 py-2">
                                            <button (click)="deleteShiftRosterEntry(entry)" 
                                                    class="text-red-600 hover:text-red-800 transition-colors duration-200">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19 7L5 7M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M10 11v6M14 11v6M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/>
                                                </svg>
                                            </button>
                                        </td>
                                    </tr>
                                } @empty {
                                    <tr>
                                    <td colspan="12" class="px-6 py-10">
                                        <div class="flex flex-col items-center justify-center text-center">
                                        <p class="text-xl font-semibold text-gray-700 mb-2">No Shift Rosters Added.</p>
                                        <p class="text-gray-500">You can add new shift rosters</p>
                                        </div>
                                    </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="pt-4 flex gap-2 justify-end">
                    <button class="button-blue" (click)="saveShiftRosters()">Save</button>
                </div>
            </div>
        </div>
    </div>
}

@if (modal.$$operatorUpdate()) {
    <div id="operation-modal" tabindex="-1" aria-hidden="true"
        class="fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
        <div class="relative p-4 max-w-xl mx-auto bg-white rounded-lg shadow-lg max-h-[90vh] overflow-visible">
            <div class="relative">
                <div class="flex items-center justify-between p-4 border-b rounded-t">
                <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                    <span>Operator Update</span>
                    <span class="status-badge ml-4"></span>
                </h3>
                <button type="button" (click)="closeUpdateModal()"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center"
                    data-modal-toggle="crud-modal">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
                </div>
            </div>
            <div class="py-4 flex flex-wrap gap-2">
                @for (op of existOperator; track op.shiftRosterId) {
                    <div class="flex items-center gap-2 bg-blue-200 rounded-lg px-3 py-2 shadow-sm"
                    [class.bg-yellow-200]="editingOperator?.shiftRosterId === op.shiftRosterId">
                    
                    <span class="text-sm font-medium cursor-pointer" (click)="startEditOperator(op)">
                        {{ op.operator }}
                    </span>

                    <!-- Delete button -->
                    <button 
                        type="button"
                        (click)="deleteOperatorAssignment(op)"
                        class="ml-1 text-red-500 hover:text-red-700 hover:bg-red-100 rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold"
                        title="Remove operator">
                        ✕
                    </button>

                    </div>
                }
            </div>

            <div>
                <div class="relative mb-4">
                            <input
                                type="search"
                                class="textField flex-1 w-full"
                                placeholder="Search Operator"
                                [(ngModel)]="searchTerm"
                                (focus)="dropdownOpenN = true"
                            />
                            
                            <ul
                                *ngIf="dropdownOpenN"
                                class="absolute bg-white border rounded-md mt-1 max-h-40 w-full overflow-y-auto z-10 shadow"
                            >
                                <li
                                    *ngFor="let operator of filteredOperatorsNew()"
                                    (click)="selectOperator(operator)"
                                    class="p-2 hover:bg-gray-100 cursor-pointer"
                                >
                                    {{ operator.operatorName | titlecase }}
                                </li>

                                <li *ngIf="filteredOperatorsNew().length === 0" class="p-2 text-gray-500">
                                    No results found
                                </li>
                            </ul>
                </div>

                <div class="flex justify-end gap-2">
                    <button class="button-gray" (click)="modal.$$operatorUpdate.set(false)">Cancel</button>
                    <button class="button-blue" (click)="updateOperatorAssignment()">Update</button>
                </div>

            </div>
            </div>
    </div>
}

